var map = {
	"./cd.png": 256,
	"./close.png": 957,
	"./computerBig.png": 114,
	"./computerSmall.png": 253,
	"./credits.png": 995,
	"./doomIcon.png": 709,
	"./forward.png": 770,
	"./henordleIcon.png": 9,
	"./maximize.png": 823,
	"./minimize.png": 825,
	"./myComputer.png": 888,
	"./pause.png": 267,
	"./play.png": 899,
	"./rewind.png": 292,
	"./scrabbleIcon.png": 754,
	"./showcaseIcon.png": 654,
	"./trailIcon.png": 550,
	"./volumeOff.png": 956,
	"./volumeOn.png": 288,
	"./windowExplorerIcon.png": 731,
	"./windowGameIcon.png": 32,
	"./windowResize.png": 161,
	"./windowsStartIcon.png": 927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;